import { API } from 'aws-amplify';
import { OnboardingInputKeys } from '../data/models/Onboarding';
import { requestOffersReview, saveOnboardingData } from '../graphql/mutations';
import { getAppVersion, only } from '../utils/helpers';
import * as type from './types';
import { getOnboardingDataByRestId } from '../graphql/queries';
import { devLog } from '../utils';
import { makeApiAction } from './actions';
import { getAppConfig } from '../constants/appConfig';

export const fetchOnboardingAction = (restId, userId, userType) => (dispatch) => {
  const getData = async () => {
    try {
      const response = await API.graphql(
        {
          query: getOnboardingDataByRestId,
          variables: {
            restId,
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        },
        {
          'user-id': userId,
          'user-type': userType,
          'rest-id': restId,
          'app-version': getAppVersion(),
          'ec-country': getAppConfig().ecCountryCode,
        },
      ).catch((error) => {
        throw new Error(error);
      });

      devLog('success', 'onboarding', response.data.getOnboardingDataByRestId);

      dispatch({
        type: type.FETCH_RESTAURANT_ONBOARDING_SUCCESS,
        payload: {
          onboarding: response.data.getOnboardingDataByRestId,
        },
      });
    } catch (error) {
      devLog('error', 'onboarding', error);

      dispatch({
        type: type.FETCH_RESTAURANT_ONBOARDING_FAILURE,
        payload: `Unable to retrieve Onboarding: ${error.message}`,
      });
    }
  };
  getData();
};

/**
 * Leave onboarding without completing
 */
export const exitOnboardingAction = (updatedOnboarding) => (dispatch) => {
  const action = 'UPDATE_RESTAURANT_ONBOARDING';

  const updatedOnboardingData = {
    ...only(updatedOnboarding, OnboardingInputKeys()),
    skippedOnboarding: true,
  };

  dispatch(
    makeApiAction(
      action,
      saveOnboardingData,
      updatedOnboardingData,
      null,
      'saveOnboardingData',
      true,
      null,
      'You have exited the EatClub tour',
      null,
      false,
      'Unable to complete onboarding. Please try again or contact your account manager.',
    ),
  );
};

/**
 * Complete onboarding
 */
export const updateOnboardingAction = (updatedOnboarding) => (dispatch) => {
  const action = 'UPDATE_RESTAURANT_ONBOARDING';

  const updatedOnboardingData = {
    ...only(updatedOnboarding, OnboardingInputKeys()),
    completedOnboarding: true,
  };

  dispatch(
    makeApiAction(
      action,
      saveOnboardingData,
      updatedOnboardingData,
      null,
      'saveOnboardingData',
      true,
      null,
      'Success, you’ve finished the EatClub tour',
      null,
      false,
      'Unable to complete onboarding. Please try again or contact your account manager.',
    ),
  );
};

/**
 * Request change to offers
 */
export const requestOffersReviewAction = () => (dispatch) => {
  const action = 'REQUEST_REVIEW_ONBOARDING';

  dispatch(
    makeApiAction(
      action,
      requestOffersReview,
      {},
      null,
      'requestOffersReview',
      true,
      null,
      'Your Account Manager has received your request and will contact you shortly.',
      null,
      false,
      'Unable to submit request. Please try again or contact your account manager.',
    ),
  );
};
